export const getUngroupedCategories = (allCategories, groupCategories) => {
  const groupedCategoryIds = new Set(
    groupCategories?.flatMap(g => g.categories.map(c => c._id)) || []
  );
  
  return allCategories.filter(cat => 
    !groupedCategoryIds.has(cat._id) && cat.enabled
  );
};